import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb, { getCategoryBreadcrumb } from '@/components/feature/Breadcrumb';
import VideoCard from '@/components/base/VideoCard';
import { categories } from '@/mocks/categories';
import { getVideosByCategory } from '@/mocks/videos';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = categories.find((c) => c.slug === slug);
  const videos = slug ? getVideosByCategory(slug) : [];

  return (
    <>
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100">
          <Breadcrumb items={slug ? getCategoryBreadcrumb(slug) : [{ label: '分类' }]} />
        </div>

        <section className="w-full py-8 md:py-10 bg-background-100">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
            <div className="flex flex-col md:flex-row gap-8">
              <aside className="w-full md:w-56 flex-shrink-0">
                <h3 className="text-sm font-semibold text-foreground-900 mb-3">全部分类</h3>
                <nav className="space-y-1">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className={`flex items-center gap-2 px-3 py-2.5 rounded-md text-sm transition-colors whitespace-nowrap ${
                        slug === cat.slug
                          ? 'bg-primary-100/70 text-primary-600 font-medium'
                          : 'text-foreground-600 hover:text-primary-500 hover:bg-background-100'
                      }`}
                    >
                      <span className={`w-6 h-6 flex items-center justify-center`}>
                        <i className={`${cat.icon} text-sm`}></i>
                      </span>
                      {cat.name}
                    </Link>
                  ))}
                </nav>
              </aside>

              <div className="flex-1 min-w-0">
                {currentCategory && (
                  <div className="mb-8">
                    <h1 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
                      {currentCategory.name}
                    </h1>
                    <p className="text-sm text-foreground-500">{currentCategory.description}</p>
                  </div>
                )}

                {videos.length > 0 ? (
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-product-shop>
                    {videos.map((video) => (
                      <VideoCard key={video.id} video={video} />
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-20">
                    <p className="text-foreground-500 text-sm">该分类暂无内容，敬请期待</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}